"use strict";

exports.__esModule = true;
exports.default = exports.CardHeader = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _clsx = _interopRequireDefault(require("clsx"));
var _excluded = ["tag", "className"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var propTypes = {
  tag: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.string])
};
var defaultProps = {
  tag: 'header'
};
var CardHeader = exports.CardHeader = function CardHeader(props) {
  var Tag = props.tag,
    className = props.className,
    attributes = _objectWithoutPropertiesLoose(props, _excluded);
  var classes = (0, _clsx.default)('uk-card__header', className);
  return /*#__PURE__*/_react.default.createElement(Tag, _extends({
    className: classes
  }, attributes));
};
CardHeader.propTypes = propTypes;
CardHeader.defaultProps = defaultProps;
var _default = exports.default = CardHeader;